import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezierRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bezier-remove, vector, nodes"} maskId="square-filled-radius-0-stroke-1-IconBezierRemove"><path d="M15 11.5H9V12.5H15V11.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V5.5H15V3H21V9H18.5V15H21V21H15V18.5H8.75V21H3V15H5.5V9H3V3ZM9 6.5V9H6.5V15H8.75V17.5H15V15H17.5V9H15V6.5H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBezierRemove;
